import React, { useRef } from "react";
import { Button } from "reactstrap";
import moment from "moment";
import { useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";

const NewRelisePdfWebView = ({
  selectedData = [],
  selecOffer = (f) => f,
  user,
  title,
}) => {
  const contentRef = useRef();
  const location = useLocation();
  const form = selectedData?.[0] || {};
  const today = moment(form.collection_date).format("Do MMMM, YYYY");
  const formattedDate = moment().format("MMMM, YYYY");

  // Check if current route is /signed-releases
  const isSignedReleasesRoute = title === "Signed Approvals";

  const calculateTotalApprovedAmount = () => {
    return selectedData.reduce(
      (total, item) => total + parseFloat(item.approved_amount),
      0,
    );
  };

  const dataByMDA = {};
  selectedData.forEach((item) => {
    if (dataByMDA[item.mda_code]) {
      dataByMDA[item.mda_code].push(item);
    } else {
      dataByMDA[item.mda_code] = [item];
    }
  });

  const handleDownload = () => {
    const opt = {
      margin: 0,
      filename: "new-relise.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["css", "legacy"] },
    };
    html2pdf().set(opt).from(contentRef.current).save();
  };

  const pageStyle = {
    width: "210mm",
    minHeight: "297mm",
    padding: "20px 50px 20px 50px",
    fontFamily: "Arial, sans-serif",
    fontSize: "10px",
    backgroundColor: "white",
    margin: "0 auto 20px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    position: "relative",
  };

  const watermarkStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(-45deg)",
    fontSize: "48px",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.05)",
    whiteSpace: "nowrap",
    pointerEvents: "none",
    userSelect: "none",
    zIndex: 1,
  };

  const contentWrapperStyle = {
    position: "relative",
    zIndex: 2,
  };

  const cellStyle = {
    border: "1px solid black",
    padding: "5px",
    fontSize: "11px",
  };

  return (
    <div
      style={{
        backgroundColor: "#f5f5f5",
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      <div ref={contentRef}>
        <div style={pageStyle}>
          {/* Watermark */}
          <div style={watermarkStyle}>
            Ministry of Budget and Economic Planning
          </div>
          {/* {JSON.stringify(dataByMDA)} */}
          {/* Content wrapper */}
          <div style={contentWrapperStyle}>
            {/* Header */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "20px",
              }}
            >
              <img
                src={require("../assets/images/pngwing.com.png")}
                style={{
                  width: "100px",
                  height: "60px",
                  marginBottom: "8px",
                }}
                alt="logo"
              />
              <div style={{ fontSize: "17px", marginTop: "10px" }}>
                MINISTRY OF BUDGET & ECONOMIC PLANNING
              </div>
              <div style={{ fontSize: "10px", fontWeight: "bold" }}>
                Old Government House Office Complex, Katsina
              </div>
              <div style={{ fontSize: "12px", fontStyle: "italic" }}>
                P.MB 2132, KATSINA
              </div>
            </div>

            {/* Reference and Date */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingBottom: "10px",
                marginTop: "10px",
              }}
            >
              <div style={{ width: "70%", fontWeight: "bold" }}>
                <span>Our Ref: </span>
                <span style={{ textDecoration: "underline" }}>
                  {form?.approval_no}
                  {/* {form?.approval_no?.includes("KTS/MBEP/BD/")
                    ? form.approval_no
                    : `KTS/MBEP/BD/${form.approval_type === "Recurrent" ? "REC" : "CAP"}/S.${form?.mda_sn}/${moment().format("YY")}/VOLI/${form?.approval_no}`} */}
                </span>
              </div>
              <div
                style={{
                  width: "30%",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                {today}
              </div>
            </div>

            {/* Subject */}
            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  textDecoration: "underline",
                  fontWeight: "bold",
                  fontSize: "11px",
                  textTransform: "uppercase",
                }}
              >
                SPECIAL RELEASE OF FUNDS
              </div>
            </div>

            {/* Body */}
            <div
              style={{
                width: "100%",
                textAlign: "justify",
                marginTop: "7px",
              }}
            >
              <p style={{ fontSize: "11px", lineHeight: "1.5" }}>
                {selectedData?.[0]?.narration || ""}
              </p>
            </div>

            {/* Table */}
            <table
              style={{
                width: "100%",
                border: "1px solid black",
                borderCollapse: "collapse",
                marginTop: "20px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      ...cellStyle,
                      width: "20%",
                      textAlign: "center",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    CODE
                  </th>
                  <th
                    style={{
                      ...cellStyle,
                      width: "60%",
                      textAlign: "center",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    MINISTRY/DEPARTMENT
                  </th>
                  <th
                    style={{
                      ...cellStyle,
                      width: "20%",
                      textAlign: "center",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    AMOUNT (N)
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(dataByMDA).map((group, grpIdx) => {
                  const total = dataByMDA[group].reduce(
                    (a, b) => a + parseFloat(b.approved_amount),
                    0,
                  );
                  return (
                    <React.Fragment key={grpIdx}>
                      <tr>
                        <td
                          style={{
                            ...cellStyle,
                            fontWeight: "bold",
                            paddingLeft: "4px",
                          }}
                        >
                          {group}
                        </td>
                        <td
                          style={{
                            ...cellStyle,
                            fontWeight: "bold",
                            paddingLeft: "4px",
                          }}
                        >
                          {dataByMDA[group][0].mda_name}
                        </td>
                        <td
                          style={{
                            ...cellStyle,
                            fontWeight: "bold",
                            textAlign: "right",
                            paddingRight: "5px",
                          }}
                        >
                          N{selecOffer(total)}
                        </td>
                      </tr>
                      {dataByMDA[group].map((item, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td style={{ ...cellStyle, paddingLeft: "4px" }}>
                              {item.approval_type === "Recurrent"
                                ? item.mda_economic_code
                                : item.program_code}
                            </td>
                            <td style={{ ...cellStyle, paddingLeft: "4px" }}>
                              {item.approval_type === "Recurrent"
                                ? item.description
                                : item.program_description}
                            </td>
                            <td
                              style={{
                                ...cellStyle,
                                textAlign: "right",
                                paddingRight: "5px",
                              }}
                            >
                              N{selecOffer(item.approved_amount)}
                            </td>
                          </tr>
                          <tr>
                            <td style={cellStyle}></td>
                            <td style={cellStyle}></td>
                            <td style={cellStyle}></td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  );
                })}
                <tr>
                  <td style={cellStyle}></td>
                  <td
                    style={{
                      ...cellStyle,
                      fontWeight: "bold",
                      textAlign: "right",
                      paddingRight: "4px",
                    }}
                  >
                    TOTAL
                  </td>
                  <td
                    style={{
                      ...cellStyle,
                      textAlign: "right",
                      paddingRight: "5px",
                    }}
                  >
                    N{selecOffer(calculateTotalApprovedAmount())}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "40px",
              }}
            >
              {/* CC Section */}
              <div style={{ width: "60%", fontSize: "10px" }}>
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  CC:
                </div>
                <div
                  style={{
                    marginLeft: "15px",
                    fontStyle: "italic",
                    fontSize: "8px",
                  }}
                >
                  <div style={{ marginBottom: "1px" }}>
                    The Permanent Secretary, Government House, Katsina,
                  </div>
                  <div style={{ marginBottom: "1px" }}>
                    The Hon. Commissioner, Ministry of Finance, Katsina,
                  </div>
                  <div style={{ marginBottom: "1px" }}>
                    The Auditor General, Office of the Auditor-General for the
                    State, Katsina,
                  </div>
                  <div style={{ marginBottom: "1px" }}>
                    The Chief of staff, Government House, Katsina,
                  </div>
                  <div style={{ marginBottom: "1px" }}>
                    The Chairman, Fiscal Responsibility Commission, Katsina,
                  </div>
                  <div style={{ marginBottom: "1px" }}>
                    The Director Main-Account, Ministry of Finance, Katsina,
                  </div>
                  {form.cc && (
                    <div style={{ marginBottom: "1px" }}>
                      {form.cc}, Katsina
                    </div>
                  )}
                </div>
              </div>

              {/* Signature */}
              <div
                style={{
                  width: "35%",
                  textAlign: "right",
                  alignItems: "right",
                }}
              >
                {(user?.imageURL || isSignedReleasesRoute) && (
                  <img
                    src={user?.imageURL || ""}
                    style={{
                      width: "80px",
                      height: "60px",
                      marginBottom: "5px",
                    }}
                    alt="signature"
                  />
                )}
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "10px",
                    marginBottom: "2px",
                  }}
                >
                  {user?.name || ""}
                </div>
                <div style={{ fontWeight: "bold", fontSize: "9px" }}>
                  DIRECTOR OF BUDGET
                </div>
                <div style={{ fontWeight: "bold", fontSize: "9px" }}>
                  FOR: HON. COMMISSIONER
                </div>
              </div>
            </div>

            {/* Signature */}
            <div style={{ marginTop: "30px", justifySelf: "right" }}>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginTop: "15px",
                  marginBottom: "10px",
                }}
              >
                Above for your information and awareness, please.
              </div>
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  alignItems: "flex-end",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: "65%",
                    alignItems: "end",
                    marginLeft: "auto",
                  }}
                >
                  {(user?.imageURL || isSignedReleasesRoute) && (
                    <img
                      src={user?.imageURL || ""}
                      style={{
                        width: "80px",
                        height: "60px",
                        marginBottom: "5px",
                      }}
                      alt="signature"
                    />
                  )}
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "10px",
                      marginBottom: "2px",
                      textAlign: "center",
                    }}
                  >
                    {user?.name || ""}
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "9px",
                      textAlign: "center",
                    }}
                  >
                    DIRECTOR OF BUDGET
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "9px",
                      textAlign: "center",
                    }}
                  >
                    FOR: HON. COMMISSIONER
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRelisePdfWebView;
